export interface LeadRequestData {
  user: string;
  client_id: string;
  request_id?: string;
  country: string;
  region?: string;
  regions?: string[];
  industry: string;
  company_size_min: number;
  company_size_max: number;
  dm_title_1: string;
  dm_title_2: string;
  dm_title_3: string;
  dm_title_4: string;
  dm_title_5: string;
  dm_title_6: string;
  dm_title_7: string;
  dm_title_8: string;
  dm_title_9: string;
  dm_title_10: string;
  dm_title_11: string;
  dm_title_12: string;
  dm_title_13: string;
  dm_title_14: string;
  dm_title_15: string;
  dm_title_16: string;
  dm_title_17: string;
  dm_title_18: string;
  dm_title_19: string;
  dm_title_20: string;
  dm_title_21: string;
  dm_title_22: string;
  dm_title_23: string;
  dm_title_24: string;
  dm_title_25: string;
  quantity_requested: number;
  assigned_to_campaign: boolean;
  campaign_id: string | null;
  include_similar_titles: boolean;
  status: string;
}

function parseEmployeeRange(range: string): { min: number; max: number } {
  if (range === '1-10') return { min: 1, max: 10 };
  if (range === '11-50') return { min: 11, max: 50 };
  if (range === '1-50') return { min: 1, max: 50 };
  if (range === '51-100') return { min: 51, max: 100 };
  if (range === '51-200') return { min: 51, max: 200 };
  if (range === '101-200') return { min: 101, max: 200 };
  if (range === '201-500') return { min: 201, max: 500 };
  if (range === '501-1000') return { min: 501, max: 1000 };
  if (range === '1000+') return { min: 1001, max: 999999 };

  console.warn(`Unrecognized employee range: ${range}`);
  return { min: 0, max: 0 };
}

export function calculateCompanySizeMinMax(employeeRanges: string[]): { min: number; max: number } {
  if (employeeRanges.length === 0) {
    return { min: 0, max: 0 };
  }

  let absoluteMin = Infinity;
  let absoluteMax = -Infinity;

  for (const range of employeeRanges) {
    const { min, max } = parseEmployeeRange(range);
    if (min > 0 && min < absoluteMin) absoluteMin = min;
    if (max > 0 && max > absoluteMax) absoluteMax = max;
  }

  return {
    min: absoluteMin === Infinity ? 0 : absoluteMin,
    max: absoluteMax === -Infinity ? 0 : absoluteMax
  };
}

const DM_TITLE_SLOTS = 25;

export function mapDmTitlesToFields(dmTitles: string[]): Record<string, string> {
  const fields: Record<string, string> = {};
  for (let i = 1; i <= DM_TITLE_SLOTS; i++) {
    fields[`dm_title_${i}`] = dmTitles[i - 1] || '';
  }
  return fields;
}

export function buildLeadRequestJson(params: {
  userEmail: string;
  clientId: string;
  requestId?: string;
  country: string;
  region?: string;
  regions?: string[];
  industry: string;
  employeeRanges: string[];
  dmTitles: string[];
  quantityNeeded: number;
  campaignId?: string | null;
  includeSimilarTitles?: boolean;
}): LeadRequestData {
  const { min, max } = calculateCompanySizeMinMax(params.employeeRanges);
  const dmTitleFields = mapDmTitlesToFields(params.dmTitles);

  return {
    user: params.userEmail,
    client_id: params.clientId,
    request_id: params.requestId,
    country: params.country,
    ...(params.regions && params.regions.length > 0 ? { regions: params.regions } : {}),
    industry: params.industry,
    company_size_min: min,
    company_size_max: max,
    ...dmTitleFields,
    quantity_requested: params.quantityNeeded,
    assigned_to_campaign: !!params.campaignId,
    campaign_id: params.campaignId || null,
    include_similar_titles: params.includeSimilarTitles !== false,
    status: 'in progress'
  } as LeadRequestData;
}
